// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixedBanner {
  position: fixed;
  bottom: 0;
  padding: 24px 48px;
  width: 100%;
  margin: 0px !important;
  background-color: #fff;
  box-shadow: 2px 2px 14px 2px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/views/commandes/commande.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EAEA,sBAAA;EAEA,+CAAA;AADJ","sourcesContent":[".fixedBanner{\n    position: fixed;\n    bottom:0;\n    padding:24px 48px;\n    width: 100%;\n    margin: 0px !important;\n    // display:flex;\n    background-color: #fff;\n    // justify-content: space-between;\n    box-shadow: 2px 2px 14px 2px rgba(0, 0, 0, 10%);\n    // align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
